import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'toWorkerStatusBadge',
})
export class WorkerUsesDraftPipe implements PipeTransform {
  private translate = inject(TranslateService);


  transform(usesDraft: boolean): string {
    const status = usesDraft ? "yes":"no";
    const text = this.translate.instant(status);
    return (
      `<div class="badge rounded-pill text-bg-light" translate>${text}</div>`
    );
  }
}
